import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisDialog from "../../components/dialog";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import moment from "moment";
import JisTabButton from "../../components/controls/jisTabButton";
import NewGif from "../../assets/new_icon.gif";
import JisDialogForm from "../../components/formdialog";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";

function GeneralCases() {
  const FeeTYPEID = 31; //this supose to be review fee
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [count, setCount] = useState(0);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(false);
  const [isGazette, setIsGazette] = useState(false);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);

 
    useEffect(() => {
     if (search != null) {
       if (pageIndex >= 0) {
         onSearch(search);
       } else {
         setPageIndex(0);
       }
     }
   }, [pageIndex, pageSize, search]);

  const onSearch = async (sear) => {
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/report/general-cases/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
          
        }
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
         if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

 

  const onCloseOpenCase = () => {
    setActive(null);
    setOpenCase(false);
  };

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };
  const onContinue = (fee, ind) => {
    //navigate(`/case-details/${caseid}`)
    setActive(fee);
    setIndex(ind);
    setOpenCase(true);
  };

  const onGotoDetails = (id) =>{
   
    navigate(`/modify-case/${id}`); //navigate to login

}
  const onDownload = async (dtype) => {
    const url = `${Constants.apiUrl}/report/download-general-cases/${dtype}`;

    // Map doctype to MIME and extension
    const typeMap = {
      excel: {
        mime: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ext: "xlsx",
      },
      msword: {
        mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ext: "docx",
      },
      pdf: {
        mime: "application/pdf",
        ext: "pdf",
      },
    };

    try {
      setLoading(true);
      const resp = await fetch(url, {
        method: "POST",
        body: JSON.stringify(search),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (!resp.ok) throw new Error("Failed to download");

      const blob = await resp.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `report.${typeMap[dtype].ext}`; // Fixed filename
      link.click();
      window.URL.revokeObjectURL(downloadUrl); // Clean up
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Download failed:", error);
    }
  };


  return (
    <div>
     <CustomSearchSortHeader
             onSearch={onDirectSearch}
             frequentData={frequentData}
             // filingtype="litigation"
           />
  {cases?.length > 0 && <div>
    <div className="exportdiv">
                <img
                  src={wordicon}
                  onClick={() => onDownload("msword")}
                  style={{ cursor: "pointer" }}
                />
                <img
                  src={excelicon}
                  onClick={() => onDownload("excel")}
                  style={{ cursor: "pointer" }}
                />
                <img
                  src={pdficon}
                  onClick={() => onDownload("pdf")}
                  style={{ cursor: "pointer" }}
                />
              </div>
  </div>} 
      <div className="table">
        <div class="section-cases">
          <span> Case Search</span>
        </div>
        <table class="case-table">
          <thead>
            <tr>
              <th>Suit Number</th>
              <th>Case Title</th>
              <th>Filing Type</th>
              <th>Classification</th>
              <th>Date Initiated</th>
              <th>Status Level</th>
              <th>View</th>
            </tr>
          </thead>
          <tbody>
            {cases?.map((opt, index) => (
              <tr key={index}>
                <td
                  style={{
                    backgroundColor: `${
                      Constants.getItemById(
                        frequentData?.casecategories,
                        opt.caseCategoryId
                      )?.colour
                    }`,
                  }}
                >
                  {" "}
                  {opt.caseNumber ?? opt.referenceNumber}
                </td>
                <td>{opt.caseTitle}</td>
                <td>
                  {Constants.getItemById(frequentData?.casetype, opt.caseTypeId)
                    ?.caseType1 || "N/A"}
                </td>
                <td>
                  {" "}
                  {Constants.getItemById(
                    frequentData?.casecategories,
                    opt.caseCategoryId
                  )?.categoryTitle || "N/A"}
                </td>
                <td>
                  {" "}
                  {Constants.momentDate(opt.createdOn).format("DD MMM, YYYY") ||
                    "N/A"}
                </td>
                <td>
                  {Constants.getItemById(
                    frequentData?.casestatuses,
                    opt.caseStatusId
                  )?.description || "N/A"}{" "}
                </td>
                <td className="col-action">
                  <JisButton
                    variant="plain"
                    onClick={() => onContinue(opt, index)}
                  >
                    View
                  </JisButton>
                </td>
                
              </tr>
            ))}
          </tbody>
        
        </table>
          {cases?.length > 0 && (
            <Pagenated
              size={pageSize}
              onChangePageSize={(k) => setPageSize(k)}
              total={count}
              maxPage={20}
              onPick={onPagePick}
            />
          )}
      </div>
      <BackLoader open={loading} />

      {openCase && active != null && (
        <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails caseId={active.caseId} data={null} token={token} />
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}
export default GeneralCases;
